import cls from 'classnames';

import { SingleToolFooter, SingleToolHeader, SingleToolSimilar } from '../../common';
import { Breadcrumb } from '../../core/Breadcrumb';

import useStyles from './styles';
import { WithLandingProps } from './types';

function WithLanding({
  className,
  analytics,
  currentTool,
  breadcrumbs,
  similarTools,
  toolCategory,
  mainArea = null,
  imageArea = null,
  otherContentArea = null,
  similarHeading,
  greyBreadcrumbsBackground,
  hasLogin,
}: WithLandingProps) {
  const classes = useStyles();

  return (
    <div className={className}>
      <SingleToolHeader
        analytics={analytics}
        className={classes.header}
        toolName={currentTool.id}
        widgetUrl={currentTool.widgetUrl}
        hasLogin={hasLogin}
      />
      <Breadcrumb
        items={breadcrumbs}
        className={cls(
          classes.breadcrumbs,

          greyBreadcrumbsBackground && classes.grey,
        )}
      />

      {mainArea}
      {imageArea}
      {otherContentArea}

      {similarTools && (
        <SingleToolSimilar
          category={toolCategory}
          current={currentTool}
          paragraph="We hand-picked these tools for you because we believe they are relevant to your search and needs. Please go and check it out."
          similar={similarTools}
          analytics={analytics}
          similarHeading={similarHeading}
        />
      )}
      <SingleToolFooter analytics={analytics} />
    </div>
  );
}

export default WithLanding;
